import React from "react";
import Spinner from "../common/progress/Spinner";
import PropTypes from "prop-types";

const Loading = ({ title }) => (
  <div className="my-nodes-page">
    <section className="main-content">
      <h1 className="text-center text-uppercase page-title">{title}</h1>;
      <div className="container">
        <div className="text-center">
          <Spinner />
        </div>
      </div>
    </section>
  </div>
);

Loading.propTypes = {
  title: PropTypes.string.isRequired
};

export default Loading;



// WEBPACK FOOTER //
// ./src/common/Loading.js